window.BackgroundCheckAPI =  new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration.getBaseAPI("BackgroundCheckServer"));

    self.getCandidateChecks = function (brandId, userId, serviceType) {

        if (!brandId) {
            throw "No brand id";
        }

        if (!userId) {
            throw "No user id";
        }

        var defer = $q.defer();
        var payload = {};
        payload.user_id = userId;

        _protected.request('brands/' + brandId + '/providers/' + serviceType + '/candidates/checks', 'GET', payload)
            .then(function (res) {
                if (res && res.data) {

                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };


    self.getSettings = function (brandId) {

        if (!brandId) {
            throw "No brand id";
        }
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/settings', 'GET')
            .then(function (res) {
                if (res && res.data) {

                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getAlllowedPositionsSettings = function (brandId) {

        if (!brandId) {
            throw "No brand id";
        }
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/settings/positions', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data.brand_position_settings) {

                    defer.resolve(res.data.data.brand_position_settings);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getPositionPackageMappings = function (brandId) {

        if (!brandId) {
            throw "No brand id";
        }
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/settings/position_package_mappings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data) {

                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getBackgroundChecksPackages = function (brandId, serviceType) {

        if (!brandId) {
            throw "No brand id";
        }
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/providers/' + serviceType + '/packages', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data.packages) {

                    defer.resolve(res.data.data.packages);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.requestNewBackgroundCheck = function (brandId, jobId, userId, packageIds, serviceType) {

        if (!brandId) {
            throw "No brand id";
        }

        if (!jobId) {
            throw "No job id";
        }

        if (!userId) {
            throw "No user id";
        }

        if (!packageIds) {
            throw "No package ids";
        }

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/providers/' + serviceType + '/candidates/checks', 'POST', {
            job_id: jobId,
            user_id: userId,
            packages: [packageIds]
        }).then(function (res) {
            if (res && res.status === 200 && res.data) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res.data);
            }
        })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.connectToProvider = function (brandId, serviceType, token) {

        if (!brandId) {
            throw "No brand id";
        }

        if (!serviceType) {
            throw "No service type";
        }

        if (!token) {
            throw "No token";
        }

        var params = {
            code : token
        }

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/providers/' + serviceType + '/auth/connect', 'POST', params)
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };


    self.disconnectProvider = function (brandId, serviceType) {

        if (!brandId) {
            throw "No brand id";
        }

        if (!serviceType) {
            throw "No service type";
        }

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/providers/' + serviceType + '/auth/disconnect', 'POST', {})
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.saveMappingSettings = function (brandId, payload) {

        if (!brandId) {
            throw "No brand id";
        }
        if (!payload) {
            throw "No payload";
        }

        var payload = payload;

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/settings', 'PUT', payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.saveAllowedPositionsSettings = function (brandId, payload) {

        if (!brandId) {
            throw "No brand id";
        }
        if (!payload) {
            throw "No payload";
        }

        var payload = payload;

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/settings/positions', 'PUT', payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };


    self.cancelBackgroundCheck = function (brandId, checkId, serviceType) {

        if (!brandId) {
            throw "No brand id";
        }

        if (!checkId) {
            throw "No check id";
        }

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/providers/' + serviceType + '/candidates/checks/' + checkId + '/cancel', 'POST')
            .then(function (res) {
            if (res && res.status === 200 && res.data) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res.data);
            }
        })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getBackgroundChecksStatuses = function (brandId, serviceType, userIds) {

        if (!brandId) {
            throw "No brand id";
        }

        if (_.isEmpty(userIds)) {
            throw "No user ids";
        }

        if (!serviceType) {
            throw "No service type";
        }

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/providers/' + serviceType + '/candidates/statuses', 'GET', userIds)
            .then(function (res) {
            if (res && res.status === 200 && res.data) {
                defer.resolve(res.data.data);
            } else {
                defer.reject(res.data);
            }
        })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getIsPositionAllowedToCheck = function (brandId, positionCode) {
        if (!brandId) {
            throw "No brand id";
        }

        if (!positionCode) {
            throw "No position code";
        }

        var defer = $q.defer();
        var payload = {
            position_code: positionCode
        };

        _protected.request('brands/' + brandId + '/allowed_positions/check', 'GET', payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getBackgroundChecksCustomization = function (brandId) {
        if (!brandId) {
            throw "No brand id";
        }
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/settings/customization', 'GET')
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.enableChecksCustomization = function (brandId) {

        if (!brandId) {
            throw "No brand id";
        }
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/settings/enable_customization', 'POST')
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.disableChecksCustomization = function (brandId) {

        if (!brandId) {
            throw "No brand id";
        }
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/settings/disable_customization', 'POST')
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };


    self.STATUSES_WEIGHT = {
        'CONSENT_REJECTED': 13,
        'DECISIONAL':12,
        'INELIGIBLE': 10,
        'ELIGIBLE': 11,
        'CLEAR': 11,
        'CONSIDER': 10,
        'DISPUTE': 9,
        'EXPIRED': 8,
        'PENDING': 7,
        'PENDING_CANDIDATE_INFO': 6,
        'CANCELLED': 5,
        'COMPLETED': 4,
        'IN_PROGRESS': 3,
        'SENDING': 2,
        'NOT_STARTED': 1,
    };
};